import React from 'react';

const defaultTheme = {
  text: '#374151',
  textMuted: '#6b7280',
  inputBorder: '#d1d5db',
  inputBg: 'white',
  primary: '#0d9488',
  focusRing: 'rgba(13, 148, 136, 0.25)',
};

function LocationSelector({ value, onChange, theme }) {
  const t = theme || defaultTheme;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', minHeight: '92px' }}>
      <label
        htmlFor="location"
        style={{
          display: 'block',
          fontSize: '14px',
          fontWeight: '600',
          color: t.text,
          marginBottom: '6px',
          height: '20px',
          flexShrink: 0,
        }}
      >
        Location
      </label>
      <input
        id="location"
        type="text"
        placeholder="e.g., United States, California, Tokyo, Germany..."
        value={value}
        onChange={(e) => onChange(e.target.value)}
        style={{
          width: '100%',
          boxSizing: 'border-box',
          minWidth: 0,
          padding: '12px 14px',
          fontSize: '15px',
          border: `1px solid ${t.inputBorder}`,
          borderRadius: '8px',
          backgroundColor: t.inputBg,
          color: t.text,
          transition: 'border-color 0.2s, box-shadow 0.2s',
          height: '46px',
        }}
        onFocus={(e) => {
          e.target.style.borderColor = t.primary;
          e.target.style.boxShadow = `0 0 0 3px ${t.focusRing}`;
        }}
        onBlur={(e) => {
          e.target.style.borderColor = t.inputBorder;
          e.target.style.boxShadow = 'none';
        }}
      />
      <div style={{ height: '20px', flexShrink: 0, fontSize: '12px', color: t.textMuted, lineHeight: 1.25, overflow: 'hidden' }} title="Enter any city, state, or country">
        Enter any city, state, or country
      </div>
    </div>
  );
}

export default LocationSelector;
